import { useCallback, useState } from 'react';
import Modal from 'ud-ui/components/modal';
import { UDButton, UDText } from 'ud-ui/components';

function useSuccessCopyModal() {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => {
    setIsOpen(true);
  }, []);
  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  return {
    modal: (
      <Modal show={isOpen} onClose={close}>
        <Modal.Header title="Копия успешно создана!" />
        <Modal.Body>
          <UDText isNew type="text-1">
            Мы добавили копию в список шаблонов
          </UDText>
        </Modal.Body>
        <Modal.Footer>
          <UDButton variant="primary" type="button" onClick={close} stretch>
            Понятно
          </UDButton>
        </Modal.Footer>
      </Modal>
    ),
    close,
    open,
  };
}

export default useSuccessCopyModal;
